// extracted by mini-css-extract-plugin
module.exports = {"form":"AppointmentsSection_form__34lwU","buttonContainer":"AppointmentsSection_buttonContainer__-dkII"};